import React from 'react';
import QueryBuilder from '@mui/icons-material/QueryBuilder';
import PlaceIcon from '@mui/icons-material/Place';
import DirectionsCar from '@mui/icons-material/DirectionsCar';
import StoreMallDirectory from '@mui/icons-material/StoreMallDirectory';
import CartIcon from '@mui/icons-material/ShoppingCart';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PropTypes from 'prop-types';
import { fulfillmentOptions } from 'constants/fulfillmentOptions';
import { getHeaderLinkLightColor } from 'styles/helpers/getThemeStyles';
import { useTheme } from '@mui/material/styles';
import { GROUP_ORDER_APP_BAR_ICON } from 'bento-ordering/group_ordering/constants/groupOrder';

const APP_BAR_ICONS = {
  [fulfillmentOptions.PICKUP]: StoreMallDirectory,
  [fulfillmentOptions.DELIVERY]: DirectionsCar,
  time: QueryBuilder,
  address: PlaceIcon,
  cart: CartIcon,
  [fulfillmentOptions.DINE_IN]: RestaurantMenuIcon,
  [GROUP_ORDER_APP_BAR_ICON]: GroupAddIcon
};

const AppBarIcon = ({ icon }) => {
  const theme = useTheme();
  const IconComponent = APP_BAR_ICONS[icon];
  let fill;
  if (icon === 'cart') {
    fill = theme.palette.header.accent.main;
  } else {
    fill = getHeaderLinkLightColor(theme);
  }
  return <IconComponent style={{ fill: fill }} />;
};

const appBarFulfillmentIconKeys = Object.keys(APP_BAR_ICONS);

AppBarIcon.propTypes = {
  icon: PropTypes.oneOf(appBarFulfillmentIconKeys)
};

export default AppBarIcon;
